<template>
    <b-modal
        id="activitySummary"
        ref="activitySummary"
        title-tag="h2"
        :scrollable="!isTreatmentboardNew"
        title="Activity Summary"
    >
        <summary-list
            v-if="_.some(params)"
            ref="summaryList"
            :params="params"
            @loading="loading = true"
            @loaded="loading = false"
        ></summary-list>
        <div slot="modal-footer" class="w-100">
            <b-button
                v-if="!loading"
                class="float-left"
                variant="secondary"
                @click="$refs.activitySummary.hide('cancel')"
                >Cancel</b-button
            >
            <div class="float-right">
                <img v-if="loading" src="assets/ajax-loader.gif" />
                <b-button-group
                    v-else-if="
                        !loading &&
                        isTreatmentboardNew &&
                        treatmentStatus.status_id > TREATMENT_STATUS.ADMITTED &&
                        !params.isOpenFromSoap
                    "
                >
                    <b-dropdown
                        @click="triggerTreatmentboardAction('history')"
                        left
                        split
                        variant="primary"
                        text="History"
                    >
                        <b-dropdown-item
                            v-if="
                                _hasAccess('schedule.treatmentboard.update') &&
                                params.status === 3
                            "
                            @click="triggerTreatmentboardAction('reactivate')"
                            >Reactivate</b-dropdown-item
                        >
                        <b-dropdown-item
                            v-if="
                                _hasAccess('schedule.treatmentboard.update') &&
                                params.status !== 3
                            "
                            @click="triggerTreatmentboardAction('edit')"
                            >Edit</b-dropdown-item
                        >
                        <b-dropdown-item
                            v-if="
                                _hasAccess('schedule.treatmentboard.create') &&
                                params.status !== 3
                            "
                            @click="triggerTreatmentboardAction('duplicate')"
                            >Duplicate</b-dropdown-item
                        >
                        <b-dropdown-item
                            v-if="
                                _hasAccess('schedule.treatmentboard.delete') &&
                                params.status === 0
                            "
                            @click="triggerTreatmentboardAction('deactivate')"
                            >Deactivate</b-dropdown-item
                        >
                        <b-dropdown-item
                            v-if="
                                _hasAccess('schedule.treatmentboard.delete') &&
                                params.status === 1
                            "
                            @click="triggerTreatmentboardAction('delete')"
                            >Delete</b-dropdown-item
                        >
                    </b-dropdown>
                </b-button-group>
            </div>
        </div>
    </b-modal>
</template>
<style></style>
<script>
import ScheduleHelper from "../helper";
import SummaryList from "./summary-list";

export default {
    name: "ActivitySummary",
    mixins: [ScheduleHelper],
    components: {
        SummaryList
    },
    data() {
        return {
            params: null,
            loading: false,
            isTreatmentboardNew: false
        };
    },
    computed: {
        treatmentStatus() {
            return this.params.treatment.treatment_status.find(
                item => item.isactive === true
            );
        }
    },
    methods: {
        open(params) {
            this.params = params;
            this.isTreatmentboardNew = params.isTreatmentboardNew;
            this.$refs["activitySummary"].show();
        },
        triggerTreatmentboardAction(action) {
            this.$emit("activity-action", action, {
                treatment: this.params.treatment,
                activity: this.params
            });
        }
    }
};
</script>
